import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ROLE_LABELS } from "@/lib/nav";
import { toast } from "sonner";

export function ChatGroupDialog({ open, onOpenChange, people, group, onSaved }) {
  const [name, setName] = useState("");
  const [ids, setIds] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { if (open) { setName(group?.name || ""); setIds(group?.member_ids || []); setQ(""); } }, [open, group]);
  const toggle = (id) => setIds((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const shown = people.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));

  const save = async () => {
    try {
      const body = { name, members: ids };
      const { data } = group ? await api.patch(`/chat/groups/${group.group_id}`, body) : await api.post("/chat/groups", body);
      toast.success(group ? "Group updated" : "Group created");
      onOpenChange(false); onSaved?.(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const remove = async () => {
    if (!window.confirm(`Delete group "${group.name}" and all its messages?`)) return;
    try { await api.delete(`/chat/groups/${group.group_id}`); toast.success("Group deleted"); onOpenChange(false); onSaved?.(null); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-md" data-testid="chat-group-dialog">
        <DialogHeader><DialogTitle>{group ? "Edit group" : "New group chat"}</DialogTitle></DialogHeader>
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Group name, e.g. Bangalore MBA team" data-testid="chat-group-name" />
        <div className="flex items-center justify-between text-xs text-slate-500"><span>{ids.length} selected</span>
          <button type="button" className="text-[#4F46E5] font-semibold" onClick={() => setIds(ids.length ? [] : shown.map((p) => p.id))} data-testid="chat-group-toggle-all">{ids.length ? "Clear" : "Select all"}</button></div>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search people" data-testid="chat-group-search" />
        <div className="max-h-64 overflow-y-auto border border-slate-100 rounded-lg divide-y divide-slate-50">
          {shown.map((p) => (
            <label key={p.id} className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-slate-50" data-testid={`chat-group-member-${p.id}`}>
              <Checkbox checked={ids.includes(p.id)} onCheckedChange={() => toggle(p.id)} /><span className="flex-1">{p.name}</span><span className="text-[11px] text-slate-400">{ROLE_LABELS[p.role]}</span>
            </label>
          ))}
        </div>
        <DialogFooter className="gap-2">
          {group && <Button variant="outline" className="text-rose-600 mr-auto" onClick={remove} data-testid="chat-group-delete">Delete group</Button>}
          <Button onClick={save} className="bg-[#4F46E5] hover:bg-[#4338CA]" data-testid="chat-group-save">{group ? "Save" : "Create group"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
